import { createAsyncThunk } from "@reduxjs/toolkit";
import { SignWithGoogle } from "../../../utils/auth/SignWithGoogle";

interface ISignInWithGoogleResponse {
  userName: string;
  token: string;
  message: string;
  userEmail: string;
  userPhoto: string | null;
  uid: string;
}

interface IRejectValue {
  message: string;
}

export const signInWithGoogle = createAsyncThunk<
  ISignInWithGoogleResponse,
  void,
  { rejectValue: IRejectValue }
>("auth/signInWithGoogle", async (_, thunkAPI) => {
  try {
    const { userData, snapShot } = await SignWithGoogle();

    if (!snapShot.exists()) {
      throw new Error("User does not exist. Please sign up first.");
    }
    return {
      userName: userData?.fullName ?? "",
      token: userData?.token ?? "",
      userPhoto: userData?.photoURL ?? "",
      message: "Successfully signed in with Google.",
      userEmail: userData?.email ?? "",
      uid: userData?.uid ?? ""
    };
  } catch (error) {
    return thunkAPI.rejectWithValue({
      message: "Error signing in with Google. Please try again later."
    });
  }
});
